export class NgxGalleryImageSize {
    static Cover: string = 'cover';
    static Contain: string = 'contain';
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/venyou-stripe/~/ngx-gallery/lib/ngx-gallery-image-size.model.ts